export default __webpack_public_path__ + "static/media/rightArrowBlack.0de4102d.svg";